module.exports = __webpack_public_path__ + "static/media/method1.52b029d5.png";